import { styled } from '@mui/material/styles';
import MuiAccordionDetails from '@mui/material/AccordionDetails';

export const AccordionDetails = styled(MuiAccordionDetails)(({ theme, bgcolor }) => ({
    padding: theme.spacing(2),
    background: `linear-gradient(90deg, ${bgcolor}, var(--color-dark0))`,
}));
